const messages = {
  "title": "Wsparcie inwestycyjne",
  "description": "Bridgestone wspiera Cię również indywidualnie w inwestycjach biznesowych. Niezależnie od tego, czy chodzi o zakup maszyn i wyposażenia warsztatu, pojazdów zastępczych czy działania marketingowe (np. reklamy lub banery online) - wykorzystaj punkty bonusowe BRIDGESTONE PLUS, aby współfinansować swoje inwestycje. Po realizacji inwestycji prześlij tutaj fakturę od dostawcy i wskaż, ile punktów bonusowych chcesz wykorzystać. Postępuj zgodnie z instrukcją poniżej.",
  "description_old": "Wsparcie inwestycyjne dla wyposażenia warsztatu i działań marketingowych",
  "info": {
    "paragraph2_old": "Zaktualizuj wyposażenie warsztatu lub strefę sprzedaży, aby lepiej promować swoje produkty. Podaj liczbę punktów, które chcesz przeznaczyć na to wsparcie. Minimalna liczba punktów to 1 250. Wartość 1 punktu = 0,25 EUR",
    "paragraph2": "Najpierw realizujesz wybraną inwestycję i opłacasz fakturę od zewnętrznego dostawcy.",
    "paragraph3_old": "Aby rozliczyć wsparcie, potrzebujemy faktury na kwotę odpowiadającą wykorzystanym punktom (liczba punktów x 0,25 EUR = kwota netto faktury) oraz kopii faktury pierwotnej. Przykładową fakturę znajdziesz",
    "paragraph3": "Następnie złóż wniosek o dofinansowanie tutaj, w polu zgłoszenia po prawej stronie.",
    "paragraph4_old": "Prosimy o kontakt osobisty w celu rozpoczęcia kolejnych kroków."
  },
  "excludeText": "Prosimy o zrozumienie, że inwestycje w bezpośrednio konkurencyjne oferty są wykluczone.",
  "here": "tutaj",
  "contactPerson": "Osoba kontaktowa",
  "email": "Email",
  "phone": "Tel",
  "payInfo": "Wypłata może potrwać do 8 tygodni!"
};

export default {
  messages,
};
